import { classNames } from '@panwds/tailwindcss';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { mergeRefs } from '../../utils/index.js';
import { CopyButton } from '../Button/index.js';
import { useTextareaAutosize } from './useTextareaAutosize.js';
import { selectBorderColor } from './textarea.logic.js';
export const Textarea = forwardRef(({ allowCopy = false, addClassName, appearance, disabled, dataMetrics, dataTestId, onChange, readOnly, rowsMax, rowsMin = 1, value, ...passThrough }, userRef) => {
    const textareaRef = useRef(null);
    const [isActive, setIsActive] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const { current: isControlled } = React.useRef(value != null);
    const ref = mergeRefs([textareaRef, userRef]);
    const hasError = appearance === 'error';
    const rootClassName = classNames('tw-border-solid tw-p-2 tw-flex tw-border tw-rounded', selectBorderColor({ hasError, active: isActive, hover: isHovered, readOnly, disabled }), readOnly
        ? 'tw-bg-black dark:tw-bg-white tw-bg-opacity-[0.04] dark:tw-bg-opacity-[0.04]'
        : 'tw-bg-white dark:tw-bg-black tw-bg-opacity-80 dark:tw-bg-opacity-16', addClassName);
    const textareaClassName = classNames('tw-font-lato tw-border-0 focus:tw-outline-none tw-placeholder-gray-500 dark:tw-placeholder-gray-400 dark:tw-text-gray-100 tw-flex-auto tw-bg-transparent tw-p-0', disabled ? 'tw-cursor-not-allowed tw-text-disabled dark:tw-text-gray-600' : 'tw-text-gray-900', readOnly && 'dark:tw-text-gray-100', allowCopy && 'tw-mt-1');
    const { height, shadowEl, syncHeight } = useTextareaAutosize({
        className: textareaClassName,
        rowsMax,
        rowsMin,
        textareaRef
    });
    useEffect(() => {
        syncHeight();
    }, [value]);
    const handleChange = (event) => {
        if (!isControlled) {
            syncHeight();
        }
        if (onChange) {
            onChange(event);
        }
    };
    const handleFocus = () => {
        setIsActive(true);
    };
    const handleBlur = () => {
        setIsActive(false);
    };
    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    return (React.createElement("span", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'textarea', className: rootClassName, style: {
            paddingBottom: '0.4375rem',
            paddingTop: '0.4375rem'
        } },
        React.createElement("textarea", { disabled: disabled, readOnly: readOnly, ref: ref, rows: rowsMin, ...passThrough, className: textareaClassName, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, style: { height }, value: value }),
        allowCopy && (React.createElement(CopyButton, { addClassName: "tw-p-0.5", style: { marginRight: '-0.125rem' }, text: () => textareaRef.current?.value })),
        shadowEl));
});
Textarea.displayName = 'Textarea';
//# sourceMappingURL=Textarea.js.map